import React from 'react'
import { BsInstagram } from 'react-icons/bs'

const SocialMedia = () => {
  return (
    <div className='app__social'>
      <div>
        <BsInstagram />
        </div>
        </div>
  )
}

export default SocialMedia